import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, empty, Observable, Subject, timer } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TimerService implements OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    private _timers: Timer[] = [];

    constructor() {
    }

    ngOnDestroy() {
        // Stop all timers
        (this._timers || []).forEach(t => t.StopTimer());
        this._subrelease.next(); this._subrelease.complete();
    }

    CreateTimer(key: string, delay: number) {
        const self = this;

        // Get the highest ID number assigned to a timer in the list of known timers.
        const highestID = (!self._timers || !self._timers.length ? 1 :
            self._timers.map(t => t.TimerID).sort((a, b) => a - b)[0] + 1);

        let newTimer = (self._timers || []).find(t => t.Key === key);

        if (newTimer == null) {
            // No timer already. Create a new one.
            newTimer = new Timer(key, highestID, delay);
            self._timers.push(newTimer);
        } else {
            // Timer is already existing. We'll return this one.
        }

        return newTimer;
    }
}

// #region Custom Classes

// #region Timer Class

export class Timer {
    Delay: number;
    Key: string;
    TimerID: number;

    private _timer: Observable<any>;
    private _timerDelay: Subject<number>;
    private _timerTick: number;
    private _subrelease: Subject<void> = new Subject<void>();

    get Timer() {
        return this._timer;
    }

    constructor(key: string, tID: number, delay: number) {
        this.Delay = delay;
        this.Key = key;
        this.TimerID = tID;

        this._timerDelay = new Subject<number>();
        this._timer = this._timerDelay.pipe(
            takeUntil(this._subrelease),
            switchMap(sdelay => sdelay ? timer(sdelay, sdelay) : empty()),
            map(t => {
                this._timerTick = t;

                return {
                    Key: this.Key,
                    Delay: this.Delay,
                    TimerID: this.TimerID
                };
            })
        );
    }

    PauseTimer() {
        this._timerDelay.next(0);
    }

    StopTimer() {
        this._timerDelay.next(0);
        this._subrelease.next(); this._subrelease.complete();
    }

    StartTimer(delay?: number) {
        if (delay == null && this.Delay != null) {
            this._timerDelay.next(this.Delay);
        } else if (delay != null) {
            this.Delay = delay;
            this._timerDelay.next(delay);
        }
    }

    toString() {
        return `Timer: {Key: ${this.Key}, TimerID: ${this.TimerID}, Timer Value: ${this._timerTick}}`;
    }
}

// #endregion

// #region Timer Info Class

export class TimerInfo {
    Delay: number;
    Key: string;
    Timer: BehaviorSubject<number>;
    TimerID: number;
}

// #endregion

// #endregion
